<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card class="noname-container">
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr :id="'r-' + item.ID">
                                <td><img :src="item.Path || '/assets/no-image.jpg'" style="width: 64px; height: 64px; cursor: pointer;" @click="viewGallery(item)"></td>
                                <td class="truncate">
                                    <v-tooltip top right>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.TransactionCode }}</span>
                                        </template>
                                        <span>{{ item.TransactionCode }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-right">{{ (!item.NumberOfPack ? 1 : item.NumberOfPack) | currency }}</td>
                                <td>{{ item.StoreCNImportDate | display_date }}</td>
                                <td class="truncate">
                                    <v-tooltip top right max-width="250">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.PublicNote }}</span>
                                        </template>
                                        <span>{{ item.PublicNote }}</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <gallery :images="images" :index="imgIndex" @close="imgIndex = null"></gallery>
    </v-container>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
import VueGallery from "vue-gallery";

export default {
    components: {
        "hpo-filter": Filtering,
        gallery: VueGallery,
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            headers: [
                {
                    text: "Hình ảnh",
                    value: "Path",
                    filterable: false,
                    quickSearch: false,
                    width: 100,
                    dataType: dataType["String"]
                },
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Số kiện",
                    value: "NumberOfPack",
                    filterable: true,
                    quickSearch: false,
                    align: "end",
                    dataType: dataType["Number"]
                },
                {
                    text: "Ngày nhập kho",
                    value: "StoreCNImportDate",
                    filterable: true,
                    dataType: dataType["Date"]
                },
                {
                    text: "Mô tả",
                    value: "PublicNote",
                    filterable: true,
                    dataType: dataType["String"]
                }
            ],
            pagination: { ...configs.PAGINATION, sortBy: ["ID"] },
            items_per_page: {...configs.ITEMS_PER_PAGE, 'items-per-page-text':'Số dòng hiển thị:', 'page-text': '{0}-{1} trên {2}'},
            viewName: "noname_list",
            filterConditions: [],
            quickFilterConditions: [],
            images: [],
            imgIndex: null
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions)
                    ? filterConditions[this.viewName]
                    : [];
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.transactions.all.data,
            total_rows: state => state.transactions.all.total,
            currentItem: state => state.transactions.selected,
            loading: state => state.transactions.loading
        }),
        param() {
            let pr = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            return pr;
        }
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("transactions/getList", this.param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy;
            let sortDesc = this.pagination.sortDesc;
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        viewGallery(item) {
            this.images = item.Paths.split(";");
            if (this.images.length > 0) {
                this.imgIndex = 0;
            }
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>